import { render, staticRenderFns } from "./InviteBtn.vue?vue&type=template&id=6ec6c9a2&scoped=true&"
import script from "./InviteBtn.vue?vue&type=script&lang=js&"
export * from "./InviteBtn.vue?vue&type=script&lang=js&"
import style0 from "./InviteBtn.vue?vue&type=style&index=0&id=6ec6c9a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec6c9a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ec6c9a2')) {
      api.createRecord('6ec6c9a2', component.options)
    } else {
      api.reload('6ec6c9a2', component.options)
    }
    module.hot.accept("./InviteBtn.vue?vue&type=template&id=6ec6c9a2&scoped=true&", function () {
      api.rerender('6ec6c9a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/projects/InviteBtn.vue"
export default component.exports